module.exports = __webpack_public_path__ + "static/media/attachment.6395a771.svg";